(async () => {
    const baseComponent = await import(window.theme.modules.baseComponent);
  
    customElements.define('product-variant-selector', class extends baseComponent.default {

        render() {
            this.addEventListener('change', this._variantChangeHandler.bind(this));
        }

        _variantChangeHandler(e) {
            this.forwardEvent('variantChange', {
                optionValueId: e.target.dataset.optionValueId, 
                optionIndex: e.target.dataset.optionIndex,
                variantId: e.target.dataset.variantId,
                imagePosition: e.target.dataset.imagePosition
            })
        }  
    });
  })();

// ============================================================
// 🧬 STEP 3 — Final universal fix (handles color swatches + text buttons)
// ============================================================

function getVariantData() {
  const data =
    window.meta?.product?.variants ||
    window.ShopifyAnalytics?.meta?.product?.variants ||
    [];
  return Array.isArray(data) ? data : [];
}

function formatPrice(cents) {
  return `$${(cents / 100).toFixed(0)}`;
}

function getCurrentSelections() {
  const clean = (t) => t?.trim().replace(/\s+/g, " ").split(/—|\$/)[0].trim() || "";
  let frame = "";
  let mount = "";

  // 🔍 STEP 1: Find the "Choose Frame" section and extract checked/selected input
  const framePicker = [...document.querySelectorAll('[class*="product-option-picker"]')].find((el) =>
    el.textContent.toUpperCase().includes("CHOOSE FRAME")
  );
  if (framePicker) {
    const checked =
      framePicker.querySelector("input[type='radio']:checked") ||
      framePicker.querySelector("[aria-checked='true']") ||
      framePicker.querySelector(".is-active, .active, .selected, .selected-swatch");

    if (checked) {
      const labelText =
        checked
          .closest("label")
          ?.querySelector('.\\#product-option-picker-value, span')?.textContent ||
        checked.value ||
        checked.textContent;
      frame = clean(labelText);
    }
  }

  // 🔍 STEP 2: Find the "Choose Mount" section
  const mountPicker = [...document.querySelectorAll('[class*="product-option-picker"]')].find((el) =>
    el.textContent.toUpperCase().includes("CHOOSE MOUNT")
  );
  if (mountPicker) {
    const active =
      mountPicker.querySelector(
        "[aria-checked='true'], .is-active, .active, .selected, input:checked + [class*='form-swatch-inner']"
      );
    if (active) mount = clean(active.textContent);
  }

  console.log("🧠 Detected selections →", { frame, mount });
  return { frame, mount };
}

function injectStep3Text() {
  const variants = getVariantData();
  if (!variants.length) return false;

  const step3 = [...document.querySelectorAll('[class*="product-option-picker"]')].find((el) =>
    el.textContent.toUpperCase().includes("CHOOSE SIZE")
  );
  if (!step3) return false;

  const swatches = step3.querySelectorAll('[class*="form-swatch-inner"]');
  if (!swatches.length) return false;

  const { frame, mount } = getCurrentSelections();

  swatches.forEach((btn) => {
    const base = btn.dataset.baseText || btn.textContent.trim().split(/—|\$/)[0].trim();
    btn.dataset.baseText = base;

    const variant = variants.find((v) => {
      const t = v.public_title?.toUpperCase() || "";
      return (
        t.includes(base.toUpperCase()) &&
        (!frame || t.includes(frame.toUpperCase())) &&
        (!mount || t.includes(mount.toUpperCase()))
      );
    });

    const price = variant ? formatPrice(variant.price) : "";

    btn.innerHTML = `
      <div style="display:flex;justify-content:space-between;align-items:center;width:100%;box-sizing:border-box;">
        <div style="flex:1;text-align:left;white-space:pre-line;line-height:1.3;">${base}</div>
        <div class="step3-price" style="flex-shrink:0;text-align:right;min-width:60px;padding-left:12px;font-weight:500;">${price}</div>
      </div>
    `;

    Object.assign(btn.style, {
      display: "block",
      padding: "12px 18px",
      width: "100%",
      boxSizing: "border-box",
    });
    btn.style.setProperty("padding-left", "18px", "important");
    btn.style.setProperty("padding-right", "18px", "important");
  });

  console.log("✅ Step 3 prices injected (v1.9.5-final)");
  return true;
}

function initStep3Watcher() {
  const success = injectStep3Text();
  if (success) {
    const reapply = () => setTimeout(injectStep3Text, 600);
    document.addEventListener("variant:change", reapply);
    document.addEventListener("change", (e) => {
      if (e.target?.name?.toUpperCase().includes("CHOOSE")) reapply();
    });
    console.log("👁️ Step 3 watcher active (v1.9.5-final)");
    return true;
  }
  return false;
}

const initPoll = setInterval(() => {
  if (document.querySelector('[class*="product-option-picker"]')) {
    if (initStep3Watcher()) clearInterval(initPoll);
  }
}, 300);
setTimeout(() => clearInterval(initPoll), 10000);
